<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="M14.8 4v1.9q0 .9 1 1 .9-.1 1-1V4H20a2 2 0 0 1 2 2v3.5q0 .4-.5.6a2 2 0 0 0 0 3.8q.5.2.5.6V18a2 2 0 0 1-2 2h-3.2v-1.9q-.1-.9-1-1a1 1 0 0 0-1 1V20H4a2 2 0 0 1-2-2v-3.5q0-.5.5-.6a2 2 0 0 0 0-3.8Q2 9.9 2 9.5V6a2 2 0 0 1 2-2zm1 8.4a1 1 0 0 0-1 1v2q0 .8 1 .9t1-1v-2q-.1-.7-1-.9m0-4.7a1 1 0 0 0-1 1v2q0 .7 1 .9.9-.1 1-1v-2q-.1-.8-1-.9"
      clip-rule="evenodd"
    />
  </svg>
</template>
